
import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router'
import { Mail } from 'react-feather'
import { Box, VBox, HBox } from './Box'
import querystring from 'query-string'
import Paragraph from './Paragraph'
import Heading from './Heading'
import IconInput from './IconInput'
import Spinner from './Spinner'
import Button from './Button'
import Spacer from './Spacer'
import Form from './Form'

const Login = withRouter(LoginWithLogic)

/**
 * Login component.
 */

export default Login


/**
 * Expose components.
 */

Login.Form = LoginForm

/**
 * Login component.
 */

function LoginWithLogic({ history, onLogin, onLoginWithCode, onLoginWithToken }) {
  const [pending, setPending] = useState(false)

  async function submit({ email }) {
    setPending(true)
    const { ref: affiliate } = querystring.parse(location.search)
    await onLogin({ email, affiliate })
    setPending(false)
  }

  async function login() {
    // auth token in fragment
    const hash = window.location.hash.slice(1)
    if (hash) {
      const [token, team_id] = hash.split('@')
      await onLoginWithToken({ token, team_id })
      history.replace('/')
      return
    }

    // code in query string
    const { email, code, team_id } = querystring.parse(location.search)
    if (email && code) {
      await onLoginWithCode({ email, code, team_id })
      history.replace('/')
      return
    }

    // switch team_id
    if (team_id) {
      localStorage.activeTeamId = team_id
      history.replace('/')
      return
    }
  }

  useEffect(_ => {
    login()
  }, [])

  return <LoginForm
    pending={pending}
    onSubmit={submit} />
}

/**
 * LoginForm component.
 */

function LoginForm({ pending, ...props }) {
  function content() {
    if (pending) {
      return <Paragraph marginTop={5} animate="show" muted>
        <Spinner marginRight={2} /> Please check your email.
      </Paragraph>
    }  

    return <Form {...props}>
      <HBox gap={2}>
        <IconInput type="text" name="email" icon={Mail} placeholder="Email" flex />
        <Button theme="primary" width={100}>Continue</Button>
      </HBox>
    </Form>
  }

  return <VBox background={0} align="center" marginTop="-5vmin" flex>
    <Box animate="show" width={330}>
      <Heading size={5}>Sign in</Heading>
      <Paragraph size={1} marginTop={4} muted>
        Enter your email and we'll send you a confirmation message to sign you in or create a new account.
      </Paragraph>
      <Spacer y={6} />
      {content()}
    </Box>
  </VBox>
}
